var _rect, _circle, _circle2, _linearGradient, _path, _linearGradient2, _path2, _path3, _linearGradient3, _path4, _rect2, _linearGradient4, _path5, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Vise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 19,
    x: 3,
    y: 13,
    fill: "#4b4f53"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 12,
    r: 2,
    fill: "#4b4f53"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 33,
    r: 2,
    fill: "#4b4f53"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "brDcaDecpQGRI5RFqINGUa",
    x1: 6,
    x2: 6,
    y1: 20.911,
    y2: 24.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1aab3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f979e"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#brDcaDecpQGRI5RFqINGUa)",
    d: "M10,25H2c-0.552,0-1-0.448-1-1v-3c0-0.552,0.448-1,1-1h8c0.552,0,1,0.448,1,1v3 C11,24.552,10.552,25,10,25z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "brDcaDecpQGRI5RFqINGUb",
    x1: 31.5,
    x2: 31.5,
    y1: 19.004,
    y2: 26.479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1aab3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f979e"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#brDcaDecpQGRI5RFqINGUb)",
    d: "M46,28H17c-0.552,0-1-0.448-1-1v-9c0-0.552,0.448-1,1-1h29c0.552,0,1,0.448,1,1v9 C47,27.552,46.552,28,46,28z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0d62ab",
    d: "M44.357,37h-0.416C42.869,37,42,36.131,42,35.059V31.66c0-0.917-0.743-1.66-1.66-1.66H27.66 C26.743,30,26,30.743,26,31.66v3.399C26,36.131,25.131,37,24.059,37h-0.416c-1.308,0-2.499,0.941-2.63,2.242 C20.863,40.738,22.034,42,23.5,42h21c1.466,0,2.637-1.262,2.487-2.758C46.857,37.941,45.665,37,44.357,37z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "brDcaDecpQGRI5RFqINGUc",
    x1: 32.5,
    x2: 32.5,
    y1: 8.543,
    y2: 26.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#007ad9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0d62ab"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#brDcaDecpQGRI5RFqINGUc)",
    d: "M35,12L35,12c0-2.761-2.239-5-5-5h0V5h-5v8h3.5c0.828,0,1.5,0.672,1.5,1.5v0 c0,0.828-0.672,1.5-1.5,1.5H28v15h12V19v-3v-0.497C40,14.673,39.327,14,38.497,14H37C35.895,14,35,13.105,35,12z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 8,
    x: 25,
    y: 5,
    fill: "#4b4f53"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "brDcaDecpQGRI5RFqINGUd",
    x1: 17.5,
    x2: 17.5,
    y1: 9.373,
    y2: 25.681,
    gradientTransform: "matrix(-1 0 0 1 33 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#007ad9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0d62ab"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#brDcaDecpQGRI5RFqINGUd)",
    d: "M13,12L13,12c0-2.761,2.239-5,5-5h0V5h5v8h-3.5c-0.828,0-1.5,0.672-1.5,1.5v0 c0,0.828,0.672,1.5,1.5,1.5H20v12c0,0.552-0.448,1-1,1H9c-0.552,0-1-0.448-1-1v-9v-3v-0.497C8,14.673,8.673,14,9.503,14H11 C12.105,14,13,13.105,13,12z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 8,
    x: 21,
    y: 5,
    fill: "#4b4f53",
    transform: "rotate(-180 22 9)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Vise);
export default __webpack_public_path__ + "static/media/icons8-vise.1de76768137b42f94fd3c117f82f2a3d.svg";
export { ForwardRef as ReactComponent };